<template>
	<div>
		<v-row>
			<v-col v-if="!titleHidden" cols="12">
				<div class="form-base__title">
					Реквизиты документа, подтверждающего полномочия представителя
				</div>
				<div class="form-base__tooltip">
					<v-icon small>{{ mdiAlertCircleOutline }}</v-icon>
					<span class="text">
            Например, доверенность или иной документ, подтверждающий
            полномочия
          </span>
				</div>
			</v-col>

			<v-col cols="9">
				<v-text-field
					v-model="v.name.$model"
					:errorMessages="getValidationErrorText(v.name)"
					label="Наименование документа"
					outlined
					@blur="v.name.$touch"
				/>
			</v-col>
			<v-col cols="3">
				<DateFieldCustom
					label="Дата выдачи"
					:value="v.docDate.$model"
					@change="v.docDate.$model = $event"
					:errorMessage="v.docDate"
					:max="new Date().toISOString()"
					@blur="v.docDate.$touch"
				/>
			</v-col>

			<v-col cols="4">
				<v-text-field
					v-model="v.issuer.$model"
					:errorMessages="getValidationErrorText(v.issuer)"
					label="Кем выдан"
					outlined
					@blur="v.issuer.$touch"
				/>
			</v-col>

			<v-col cols="4">
				<v-text-field
					v-model="v.series.$model"
					:errorMessages="getValidationErrorText(v.series)"
					label="Серия документа"
					outlined
					@blur="v.series.$touch"
				/>
			</v-col>

			<v-col cols="4">
				<v-text-field
					v-model="v.number.$model"
					:errorMessages="getValidationErrorText(v.number)"
					label="Номер документа"
					outlined
					@blur="v.number.$touch"
				/>
			</v-col>

			<v-col cols="12">
				<v-text-field
					v-model="v.attestation.$model"
					:errorMessages="getValidationErrorText(v.attestation)"
					label="Сведения об удостоверении документа"
					outlined
					@blur="v.attestation.$touch"
				/>
			</v-col>

			<v-col cols="12">
				<AttachDocumentSingle
					:load-profile-document-type="DocumentType.CONFIRMATION_OF_AUTHORITY"
					:value="{
            file: v.file.$model,
            fileSig: v.fileSig.$model
          }"
					:error-messages="getValidationErrorText(v.file)"
					@change="
            v.file.$model = $event.file;
            v.fileSig.$model = $event.fileSig;
          "
					@change-from-profile="
            v.name.$model = $event.name;
            v.docDate.$model = $event.docDate;
            v.issuer.$model = $event.issuer;
            v.attestation.$model = $event.attestation;
            v.file.$model = $event.file;
            v.fileSig.$model = $event.fileSig;
          "
					:has-description="isNoticeRecovery"
					:with-select="isNoticeRecovery"
					:document-types="documentTypes"
				/>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import {and, maxLength, required} from 'vuelidate/lib/validators';
import {mdiAlertCircleOutline} from '@mdi/js';
import {
	DATE_FORMAT,
	DATE_FUTURE,
	DATE_PAST,
	EMOJI,
	getValidationErrorText, TRAILING_AND_LEADING_SPACES,
} from '@/utils/validate';
import DateFieldCustom from '@/components/base/DateFieldCustom';
import {DocumentType} from '@/types/services';
import AttachDocumentSingle from '@/components/base/AttachDocument/AttachDocumentSingle';
import {UploadDocumentTypes} from "@/utils/uploadDocumentTypes";
import {StatementType} from "@/constants";
import { isNoticeRecoveryClassifierEnable } from '@/app.config';

export const authorityDocumentValidation = {
	name: {
		required,
		maxLength: maxLength(1000),
		EMOJI,
		TRAILING_AND_LEADING_SPACES
	},
	docDate: {
		required,
		DATE: and(DATE_FORMAT, DATE_FUTURE, DATE_PAST),
	},
	issuer: {
		required,
		maxLength: maxLength(1000),
		EMOJI,
		TRAILING_AND_LEADING_SPACES
	},
	attestation: {
		maxLength: maxLength(4000),
		EMOJI,
		TRAILING_AND_LEADING_SPACES
	},
	number: {
		EMOJI,
		maxLength: maxLength(50),
		TRAILING_AND_LEADING_SPACES
	},
	series: {
		EMOJI,
		maxLength: maxLength(25),
		TRAILING_AND_LEADING_SPACES
	},
	file: {},
	fileSig: {},
};

export const authorityDocumentModel = {
	type: DocumentType.CONFIRMATION_OF_AUTHORITY,
	name: '',
	docDate: '',
	issuer: '',
	attestation: '',
	number: '',
	series: '',
	file: null,
	fileSig: null,
};

export default {
	name: 'AuthorityDocument',
	components: {
		DateFieldCustom,
		AttachDocumentSingle,
	},
	props: {
		v: {
			type: Object,
			required: true,
		},
		titleHidden: {
			type: Boolean,
		},
		statementType: {
			type: String,
			required: true,
		},
	},
	data: () => ({
		mdiAlertCircleOutline,
		getValidationErrorText,
		DocumentType,
		StatementType
	}),
	computed: {
		isNoticeRecovery() {
			return this.statementType === this.StatementType.NOTICE_RECOVERY && isNoticeRecoveryClassifierEnable
		},
		documentTypes() {
			const docsCodes = ['12302']
			return UploadDocumentTypes
				.filter((item) => ['12300'].includes(item.groupCode))
				.map((item) => {
					return {
						...item,
						documents: item.documents.filter((doc => docsCodes.includes(doc.value)))
					}
				})
		}
	}
};
</script>
